import { sessionService } from "redux-react-session";

export const setLocalLogin = (token) =>{
 
  localStorage.setItem('fusion-token', token);
  return true;
};

export const setLocalRole = (roleId) =>{
 
  localStorage.setItem('fusion-role', roleId);
  return true;
};

export const setAuthenticate = (token) =>{
   localStorage.setItem('authenticated', true);
   return true;
};

export const getLocalLogin = () =>{
  return localStorage.getItem('fusion-token');
}
export const setServiceAsync = async (key, data) => {
  return localStorage.setItem(key,JSON.stringify(data));
};
export const setAsync = async (key, data) => {
  return localStorage.setItem(key,JSON.stringify(data.data));
};
export const getAsync = async (key) => {
  return localStorage.getItem(key);
};

export const setSession = (token) => {
  return sessionService
    .saveSession(token)
    .then(() => {})
    .catch((err) => console.error(err));
};
export const getSession = () => {  
  return sessionService
    .loadSession()
    .then((token) => token)
    .catch((err) => {
      // sessionService.deleteSession();
      console.error(err);
    });
    
};
// export const setAsync = async (key, data) => {
//   const user = await sessionService
//     .loadUser()
//     .then((user) => user)
//     .catch((err) => null);
//   if (user) {
//     const copyUser = { ...user };
//     copyUser[key] = data;
//     return sessionService
//       .saveUser(copyUser)
//       .then(() => {})
//       .catch((err) => console.error(err));
//   } else {
//     return sessionService
//       .saveUser({ [key]: data })
//       .then(() => {})
//       .catch((err) => console.error(err));
//   }
// };
// export const getAsync = async (key) => {
//   const user = await sessionService
//     .loadUser()
//     .then((user) => user)
//     .catch((err) => null);
//   if (user) {
//     return user[key];
//   } else {
//     return null;
//   }
// };
export const fetchAllItems = async () => {
  const user = await sessionService
    .loadUser()
    .then((user) => user)
    .catch((err) => null);
  if (user) {
    return user;
  } else {
    return null;
  }
};

export const removeAsync = async function removeData(key) {
  try {
    await localStorage.removeItem(key);
  } catch (error) {
    console.warn("Async Error remove error", error);
  }
};

export const clearStorage = async () => {
  try {
    await localStorage.clear();
  } catch (error) {
    console.warn("Async Error while clearing", error);
  }
  return {};
};

export const setRefreshToken = (token) =>{
  localStorage.setItem('fusion-refresh-token', token);
  return true;
};
export const getRefreshLogin = () =>{
  return localStorage.getItem('fusion-refresh-token');
};
export const logoutUser = () => {
  localStorage.removeItem('fusion-token');
  localStorage.removeItem('profileDetails');
  localStorage.removeItem('loginDetails');
  localStorage.removeItem('fusion-refresh-token');
  localStorage.clear();
  sessionStorage.clear();
  return true;
}
